import { toast } from "react-toastify";
import {
    AddUserDto,
    CreateGroupDto,
    GroupDto,
    UpdateGroupDto
} from "../Types/GroupServiceTypes";

import {
    apiGet,
    apiPost,
    apiPut,
    apiDelete,
    apiPublicGet
} from "./apiClient";

/* ============================================================
   PUBLIC ENDPOINTS
============================================================ */

const GetGroups = async (): Promise<GroupDto[] | undefined> => {
    try {
        return await apiGet<GroupDto[]>("/groups");
    } catch (err) {
        console.error(err);
        toast.error("Ett tekniskt fel uppstod (groups)");
        return undefined;
    }
};

const GetGroupById = async (id: string): Promise<GroupDto | undefined> => {
    try {
        const data = await apiGet<GroupDto>(`/groups/${id}`);
        return data;
    } catch (err) {
        console.error(err);
        toast.warning("Gruppen kunde inte hittas");
        return undefined;
    }
};

/* ============================================================
   PROTECTED ENDPOINTS (Admins)
============================================================ */

const CreateGroup = async (
    dto: CreateGroupDto
): Promise<GroupDto | undefined> => {
    try {
        const res = await apiPost<GroupDto>("/groups", dto);
        toast.success("Grupp skapad & inbjudningar skickade!");
        return res;
    } catch (err: any) {
        console.error(err);
        toast.error("Tekniskt fel vid skapande av grupp");
        return undefined;
    }
};

const UpdateGroup = async (
    id: string,
    dto: UpdateGroupDto
): Promise<boolean> => {
    try {
        await apiPut(`/groups/${id}`, dto);
        toast.success("Grupp uppdaterad");
        return true;
    } catch (err) {
        toast.warning("Kunde inte uppdatera grupp");
        return false;
    }
};

const DeleteGroup = async (id: string): Promise<boolean> => {
    try {
        await apiDelete(`/groups/${id}`);
        toast.success("Grupp borttagen");
        return true;
    } catch (err) {
        toast.warning("Kunde inte ta bort grupp");
        return false;
    }
};

const AddUserToGroup = async (
    groupId: string,
    email: string
): Promise<boolean> => {
    const dto: AddUserDto = { email };

    try {
        await apiPost(`/groups/${groupId}/users`, dto);
        toast.success("Användare tillagd");
        return true;
    } catch (err) {
        toast.warning("Kunde inte lägga till användare");
        return false;
    }
};

const RemoveUserFromGroup = async (
    groupId: string,
    userId: string
): Promise<boolean> => {
    try {
        await apiDelete(`/groups/${groupId}/users/${userId}`);
        toast.success("Användare borttagen");
        return true;
    } catch (err) {
        toast.warning("Kunde inte ta bort användare");
        return false;
    }
};

/* ============================================================
   EXPORT
============================================================ */

export const GroupService = {
    // Public
    GetGroups,
    GetGroupById,

    // Protected
    CreateGroup,
    UpdateGroup,
    DeleteGroup,
    AddUserToGroup,
    RemoveUserFromGroup
};
